/*Allowd to upload image extentions_________________________________________*/
export const uploadImgExtensions = ["jpg","jpeg","png"]

/*Allowd to upload file extentions_________________________________________*/
export const uploadFileExtensions = ["dwg", "rvt", "nwd", "tiff", "doc","docm","docx","dotm","xlsx", "xlsm", "xltx", "xltm", "ppt", "pptx", "csv","zip","rar","pdf","txt","xml","html","mp4","mov","flv","avi", "mpeg","mpv"]

/* File & Image Extensions_________________________________________________*/
export const imgExt = ["jpg","jpeg","png"]
export const docExt = ["doc","docm","docx","dotm"]
export const excelExt = ["xlsx", "xlsm", "xltx", "xltm"]
export const pptExt = ["ppt", "pptx"]
export const csvExt = ["csv"]
export const zipExt = ["zip"]
export const rarExt = ["rar"]
export const pdfExt = ["pdf"]
export const txtExt = ["txt"]
export const xmlExt = ["xml"]
export const htmlExt = ["html"]
export const videoExt = ["mp4","mov","flv","avi", "mpeg","mpv"]
export const tiffExt = ["tiff"]
export const rvtExt = ["rvt"]
export const nwdExt = ["nwd"]
export const dwgExt = ["dwg"]
export const _IS_ATTACHED_FILE_LIMIT_EXISTED = false;

export const IS_IDLE_STATE = true;

export const getFileExtensionType = (extentions) => {
	let _type = extentions;
	if(imgExt.includes(extentions)) {
		_type = "img";
	}else if(docExt.includes(extentions)) {
		_type = "doc";
	} else if (excelExt.includes(extentions)) {
		_type = "excel";
	} else if (pptExt.includes(extentions)) {
		_type = "ppt";
	} else if (csvExt.includes(extentions)) {
		_type = "csv";
	} else if (pdfExt.includes(extentions)) {
		_type = "pdf";
	} else if (txtExt.includes(extentions)) {
		_type = "txt";
	} else if (xmlExt.includes(extentions)) {
		_type = "xml";
	} else if (htmlExt.includes(extentions)) {
		_type = "html";
	} else if (videoExt.includes(extentions)) {
		_type = "video";
	} else if (zipExt.includes(extentions)) {
		_type = "zip";
	} else if (rarExt.includes(extentions)) {
		_type = "rar";
	} else if (tiffExt.includes(extentions)) {
		_type = "tiff";
	} else if (rvtExt.includes(extentions)) {
		_type = "rvt";
	} else if (nwdExt.includes(extentions)) {
		_type = "nwd";
	// } else if (nwdExt.includes(extentions)) {
	// 	_type = "nwd";
	} else if (dwgExt.includes(extentions)) {
		_type = "dwg";
	}
	return _type
}

export const getFileIconLink = (_fileExt = null) => {
	let _fileIcon = ""
	if(_fileExt != null) {
		if(_fileExt === "doc") {
			_fileIcon = "/static/images/file-icons/doc.svg"
		} else if (_fileExt === "excel"){
			_fileIcon = "/static/images/file-icons/xls.svg"
		} else if (_fileExt === "ppt"){
			_fileIcon = "/static/images/file-icons/ppt.svg"
		} else if (_fileExt === "csv"){
			_fileIcon = "/static/images/file-icons/csv.svg"
		} else if (_fileExt === "pdf"){
			_fileIcon = "/static/images/file-icons/pdf.svg"
		} else if (_fileExt === "txt"){
			_fileIcon = "/static/images/file-icons/txt.svg"
		} else if (_fileExt === "xml"){
			_fileIcon = "/static/images/file-icons/xml.svg"
		} else if (_fileExt === "html"){
			_fileIcon = "/static/images/file-icons/html.svg"
		} else if (_fileExt === "video"){
			_fileIcon = "/static/images/file-icons/mp4.svg"
		} else if (_fileExt === "zip"){
			_fileIcon = "/static/images/file-icons/zip.svg"
		} else if (_fileExt === "rar"){
			_fileIcon = "/static/images/file-icons/rar.svg"
		} else if (_fileExt === "tiff"){
			_fileIcon = "/static/images/file-icons/tiff.svg"
		} else if (_fileExt === "rvt"){
			_fileIcon = "/static/images/file-icons/rvt.svg"
		} else if (_fileExt === "nwd"){
			_fileIcon = "/static/images/file-icons/nwd.svg"
		} else if (_fileExt === "dwg"){
			_fileIcon = "/static/images/file-icons/dwg.svg"
		} else if (_fileExt === "mp3"){
			_fileIcon = "/static/images/file-icons/mp3.svg"
		}
	}
	return _fileIcon;
}

// Initialize Page title notification on tab
export const PageTitleNotification = {
	Vars:{
		OriginalTitle: document.title,
		Interval: null
	},
	On: function(notification, intervalSpeed){
		var _this = this;
		_this.Vars.Interval = setInterval(function(){
			document.title = (_this.Vars.OriginalTitle === document.title)
								? notification
								: _this.Vars.OriginalTitle;
		}, (intervalSpeed) ? intervalSpeed : 1000);
	},
	Off: function(){
		clearInterval(this.Vars.Interval);
		document.title = this.Vars.OriginalTitle;
	}
}

export const isWebCamAvailable = async () => {
	let _isAvailable = false;
	let stream = null
	try {
		if(navigator.mediaDevices !== undefined) {
			stream = await navigator.mediaDevices.getUserMedia({video:true, audio:true});
			await stream.getTracks().forEach(function(track) {
			  track.stop();
			});
			_isAvailable = true
		} else {
			_isAvailable = false;
		}
	} catch (err) {
		// console.log(err)
		_isAvailable = false;
	}
	return _isAvailable
}

export const isWebcamDetect =  async () => {
	//let VIDEO_SOURCE = null;
	let _return = false
	let md = navigator.mediaDevices;
  if (md && md.enumerateDevices){
	  await md.enumerateDevices().then(devices => {
			if(devices !== undefined && devices.length > 0) {
				let _index = devices.findIndex(x=>x.kind === 'videoinput');
				if (_index > -1) {
					_return = true;
					//let _device = devices.find(x=>x.kind === 'videoinput' && x.deviceId !== "default");
					//VIDEO_SOURCE = _device.deviceId
				} else {
					_return = false;
				}
			}
	  })
  }
	return _return;
}

export const timeDiffInHourMinSecFromNow = async (_startTime, _endTime = new Date().getTime()) => {
	// get total seconds between the times
	var delta = Math.abs(_endTime - _startTime) / 1000;

	// calculate (and subtract) whole days
	var days = Math.floor(delta / 86400);
	delta -= days * 86400;

	// calculate (and subtract) whole hours
	var hours = Math.floor(delta / 3600) % 24;
	delta -= hours * 3600;

	// calculate (and subtract) whole minutes
	var minutes = Math.floor(delta / 60) % 60;
	delta -= minutes * 60;

	// what's left is seconds
	var seconds = parseInt(delta % 60, 10);  // in theory the modulus is not required

	var _time = "";
	if(hours > 0) {
		_time = hours;
	}
	if(minutes > 0) {
		if (_time === "") {
			_time = ("0" + minutes).slice(-2);
		} else {
			_time += ":"+ ("0" + minutes).slice(-2)
		}
	}
	if(seconds > 0) {
		if (_time === "") {
			_time = "00:" + ("0" + seconds).slice(-2);
		} else {
			_time += ":"+ ("0" + seconds).slice(-2)
		}
	} else {
		_time = "00:00";
	}
	return _time;
}

export const timeDiffInSecond = async (_startTime, _endTime = new Date().getTime()) => {
	return parseInt((_endTime - _startTime) / 1000)
}

export const getDeviceId = async () => {
	let _browserToken = window.localStorage.getItem("s_b_w_token")
	if(!_browserToken) {
		  _browserToken = await Date.now().toString();
	  await window.localStorage.setItem("s_b_w_token", _browserToken);
		  return _browserToken
	} else {
		  return _browserToken
	  }
}

export const getAuthToken = () => {
	let _localData = window.localStorage.getItem("current_user")
	let _data;
	let authToken;
	if(_localData && _localData !== undefined) {
		_data = JSON.parse(_localData)
		authToken = _data.authToken
	}
	return authToken
}